export default __webpack_public_path__ + "static/media/main_keyboard_skin.88cd6d7f.jpeg";